import { render, staticRenderFns } from "./PatientDownloableAttachment.vue?vue&type=template&id=f4131cc4&scoped=true&"
import script from "./PatientDownloableAttachment.vue?vue&type=script&lang=js&"
export * from "./PatientDownloableAttachment.vue?vue&type=script&lang=js&"
import style0 from "./PatientDownloableAttachment.vue?vue&type=style&index=0&id=f4131cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4131cc4",
  null
  
)

export default component.exports